import { ToggleMainSectionDto, contentClient, fetchAllData } from "@eolas-medical/core";
import { useMutation } from "@tanstack/react-query";

const useToggleMainSection = () => {
  const { mutate, isLoading, isSuccess, error } = useMutation(
    async ({ id, disabled }: ToggleMainSectionDto) => {
      await contentClient.toggleMainSection({ id, disabled });
    },
    {
      onSuccess: async () => {
        await fetchAllData();
      },
    },
  );

  return {
    toggleMainSection: mutate,
    togglingMainSection: isLoading,
    toggleMainSectionSuccess: isSuccess,
    toggleMainSectionError: error as string,
  };
};

export default useToggleMainSection;
